export default __webpack_public_path__ + "static/hill_descent-39ee1046de625ea7b5a0893baf8b15a3.mp4";